
import backButtonMixin from "@/mixins/back-button"

export default backButtonMixin.extend({})
